module.exports = __webpack_public_path__ + "static/media/hr-logo-full.f65c7024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hr-logo-full.png
// module id = 603
// module chunks = 0